import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from '../../common/service/user-profile.service';
import { environment } from '../../../environments/environment';
import { trimEnd, trimStart } from 'lodash';

export function isInternalUrl(url: string): boolean {
  return !url.startsWith('http');
}

export function addServerPartAndLoggedUserIdToUrl(url: string | null, userProfileService: UserProfileService, firstParameter: boolean = false): string {
  return environment.serverUrl + addLoggedUserIdToUrl(url, userProfileService, firstParameter);
}

export function addLoggedUserIdToUrl(url: string | null, userProfileService: UserProfileService, firstParameter: boolean = false): string {
  let separator = '&';
  if (firstParameter)
    separator = '?';

  if (url)
    return `${url}${separator}userId=${userProfileService.getUserProfile().username}`;
  return null;
}

export function snakeCaseToCamelCase(text: string): string {
  text = text.replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
  return text.substr(0, 1).toLowerCase() + text.substr(1);
}

export function trimStartEnd(name: string): string {
  return trimEnd(trimStart(name));
}

/** Znaki diakrytyczne wydzielone przez NFD (U+0300–U+036F) — wycinamy je przy porównywaniu nazw. */
const COMBINING_MARKS = /[\u0300-\u036f]/g;

/** Kreskowane ł nie jest w NFD rozbijane na literę i znak diakrytyczny, więc trzeba je podmienić osobno. */
const POLISH_STROKED_L = /\u0142/g;

/** Postać do porównań przy wyszukiwaniu: bez wielkości liter i bez ogonków, żeby „urzadzen" znajdowało „urządzeń". */
export function normalizeForSearch(text: string): string {
  return text.toLowerCase().normalize('NFD').replace(COMBINING_MARKS, '').replace(POLISH_STROKED_L, 'l');
}

/**
 * Porządek alfabetyczny liczony na przetłumaczonych nazwach, a nie na kluczach. `localeCompare` z aktualnym
 * językiem układa przy tym ogonki tam, gdzie ich oczekuje alfabet danego języka.
 */
export function compareTranslated(translate: TranslateService, oneKey: string, twoKey: string): number {
  return translate.instant(oneKey).localeCompare(translate.instant(twoKey), translate.currentLang || 'pl');
}
